<template>
  <span class="audit-entities-multiselect">
    <vt-combo-select
      v-model="selectedEntityTypes"
      v-testing="'entities-types'"
      track-by="id"
      :option-loader="loadAllEntityTypes"
      label="name"
      :multiple="true"
      class="multiselection multiselect--sidebar"
    />
    <vt-combo-select
      v-if="visibleSingleEntitySearchCombo"
      ref="entitiesMultiSelect"
      :key="selectedEntityTypes.length > 0 ? selectedEntityTypes[0].id : 0"
      v-model="selectedEntities"
      v-testing="'selected-entities'"
      class="mt-2 multiselection multiselect--sidebar"
      :option-loader="searchByEntityType"
      :custom-label="getCustomLabel"
      multiple
      ajax-search
    />
    <vt-input
      v-else-if="visibleMultiEntitySearchTextInput"
      v-model="multiEntitySearchQuery"
      v-testing="'selected-entities'"
      size="sm"
      class="mt-2"
    />
  </span>
</template>

<script>
import auditedActionService, { AUDITED_ENTITY_TYPES } from '@/modules/auditModule/services/AuditedActionService'
import commonUserServices from '@/api/resources/common/commonUserServices'
import commonPatientServices from '@/api/resources/common/commonPatientServices'
import commonCaseServices from '@/api/resources/common/commonCaseServices'
import commonSampleService from '@/api/resources/common/commonSampleService'
import commonPortionServices from '@/api/resources/common/commonPortionServices'
import commonSubportionServices from '@/api/resources/common/commonSubportionServices'
import commonRequestService from '@/api/resources/common/commonRequestService'
import commonIncidentServices from '@/api/resources/common/commonIncidentServices'
import commonComplementaryService from '@/api/resources/common/commonComplementaryService'
import { auditSearchService } from '@/modules/auditModule/services/audit-search.service'

export default {
    name: 'AuditEntitiesMultiselect',
    data() {
        return {
            selectedEntityTypes: [],
            selectedEntities: null,
            multiEntitySearchQuery: null
        }
    },
    computed: {
        visibleMultiEntitySearchTextInput() {
            return this.selectedEntityTypes.length > 1
        },
        visibleSingleEntitySearchCombo() {
            return this.selectedEntityTypes.length === 1
        }
    },
    watch: {
        selectedEntityTypes: {
            handler() {
                this.selectedEntities = []
                this.multiEntitySearchQuery = ''
            },
            deep: true
        }
    },
    methods: {
        async loadAllEntityTypes() {
            return auditedActionService.findAllEntityTypesSorted()
        },
        async searchByEntityType(query) {
            if (!query || this.isSelectEntitiesDisabled) {
                return []
            }
            const params = {
                query,
                size: 10
            }
            switch (this.selectedEntityTypes[0].id) {
            case AUDITED_ENTITY_TYPES.USER.id:
                return commonUserServices.search(params)
            case AUDITED_ENTITY_TYPES.PATIENT.id:
                return commonPatientServices.search(params)
            case AUDITED_ENTITY_TYPES.CASE.id:
                return commonCaseServices.search(params)
            case AUDITED_ENTITY_TYPES.SAMPLE.id:
                return commonSampleService.search(params)
            case AUDITED_ENTITY_TYPES.PORTION.id:
                return commonPortionServices.search(params)
            case AUDITED_ENTITY_TYPES.SUBPORTION.id:
                return commonSubportionServices.search(params)
            case AUDITED_ENTITY_TYPES.REQUEST.id:
                return commonRequestService.search(params)
            case AUDITED_ENTITY_TYPES.INCIDENT.id:
                return commonIncidentServices.search(params)
            case AUDITED_ENTITY_TYPES.COMPLEMENTARY.id:
                return commonComplementaryService.search(params)
            case AUDITED_ENTITY_TYPES.SHIPMENTS.id:
                return auditSearchService.search(params)
            default:
                return []
            }
        },
        getCustomLabel(option) {
            return option.laboratoryExternalId
                ? `${option.label} (${option.laboratoryExternalId})`
                : option.label
        },
        clear() {
            this.selectedEntityTypes = []
            this.selectedEntities = null
            this.multiEntitySearchQuery = null
        }
    }
}
</script>

<style lang="scss">
   .audit-entities-multiselect .multiselection .multiselect__tags {
        line-height: 1.3 !important;
        height: auto !important;
    }

   .audit-entities-multiselect .multiselection .multiselect__input, .multiselect__single{
        margin-bottom: 0 !important;
        line-height: 1.3 !important;
        min-height: 18.5px !important;
    }
</style>
